<template>
  <main id="home" class="page-container" v-if="$route.path === '/home'">
    <!-- <div id="square">
      <router-link to="/home/clients" class="router-link-reset">
        <div id="customers" class="square">
          <img
            src="@/assets/account_circle.png"
            alt="customer"
            class="home_icons"
          />
          <p>Clienti</p>
        </div>
      </router-link>
      <router-link to="/home/quotes" class="router-link-reset">
        <div id="quotes" class="square">
          <span class="euro_icon home_icons">€</span>
          <p>Preventivi</p>
        </div>
      </router-link>
      <router-link to="/home/stock" class="router-link-reset">
        <div id="items" class="square">
          <img src="@/assets/icon_carrier.png" alt="stock" class="home_icons" />
          <p>Magazzino</p>
        </div>
      </router-link>
      <router-link to="/home/orders" class="router-link-reset">
        <div id="orders" class="square">
          <i class="fa-solid fa-truck"></i>
          <p>Ordini fuori magazzino</p>
        </div>
      </router-link>
    </div> -->
    <section id="square" class="cards-grid">
      <router-link to="/home/clients" class="card" aria-label="Clienti">
        <span class="icon-wrap">
          <img src="@/assets/account_circle.png" alt="" />
        </span>
        <span class="label">Clienti</span>
      </router-link>

      <router-link to="/home/quotes" class="card" aria-label="Preventivi">
        <span class="icon-wrap">
          <span class="euro_icon">€</span>
        </span>
        <span class="label">Preventivi</span>
      </router-link>

      <router-link to="/home/drafts" class="card" aria-label="Bozze Preventivi">
        <span class="icon-wrap">
          <i class="fa-solid fa-file-pen" aria-hidden="true"></i>
        </span>
        <span class="label">Bozze Preventivi</span>
      </router-link>

      <router-link to="/home/stock" class="card" aria-label="Magazzino">
        <span class="icon-wrap">
          <img src="@/assets/icon_carrier.png" alt="" />
        </span>
        <span class="label">Magazzino</span>
      </router-link>

      <router-link
        to="/home/orders"
        class="card"
        aria-label="Ordini fuori magazzino"
      >
        <span class="icon-wrap">
          <i class="fa-solid fa-truck" aria-hidden="true"></i>
        </span>
        <span class="label">Ordini fuori magazzino</span>
      </router-link>

      <!-- Console/Pannello Assistenza RIMOSSO dal CRM: nel CRM tutti sono richiedenti
           assistenza; il support/admin vive su assistenza-central [sc-47544 8C-Emma-6]. -->

      <button
        type="button"
        class="card card-search"
        aria-label="Cerca preventivi per articolo"
        @click="openSearchModal"
      >
        <span class="icon-wrap">
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        </span>
        <span class="label">Cerca per articolo</span>
      </button>
    </section>

    <!-- MODALE RICERCA PREVENTIVI PER ARTICOLO -->
    <VueFinalModal
      v-model="showSearchModal"
      :clickToClose="!searching"
      :escToClose="!searching"
      classes="search-modal"
      content-class="search-modal-content"
    >
      <template #default>
        <button
          class="search-modal__close"
          @click="closeSearchModal"
          aria-label="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="search-modal__title">Cerca preventivi per articolo</h3>

        <form class="search-modal__form" @submit.prevent="runSearch()">
          <div class="search-modal__input-wrap">
            <input
              ref="searchInput"
              v-model="searchTerm"
              type="text"
              class="search-modal__input"
              placeholder="Nome articolo…"
              aria-label="Nome articolo"
              autocomplete="off"
              @input="onSearchInput"
            />
            <button
              v-if="searchTerm"
              type="button"
              class="search-modal__clear"
              aria-label="Cancella ricerca"
              title="Cancella"
              @click="clearSearch"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
          </div>
          <button
            type="submit"
            class="search-modal__btn"
            :disabled="searching || !searchTerm.trim()"
          >
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            Cerca
          </button>
        </form>

        <ul
          v-if="showSuggestions && suggestions.length"
          class="search-suggestions"
        >
          <li
            v-for="(s, i) in suggestions"
            :key="i"
            class="search-suggestion"
            @mousedown.prevent="selectSuggestion(s)"
          >
            <i
              class="fa-solid fa-tag search-suggestion__icon"
              aria-hidden="true"
            ></i>
            <span class="search-suggestion__name">{{ s.name }}</span>
            <span class="search-suggestion__source">{{
              s.source === "stock" ? "Magazzino" : "Fuori magazzino"
            }}</span>
          </li>
        </ul>

        <div class="search-modal__results">
          <div v-if="searching" class="search-modal__status">
            Ricerca in corso…
          </div>
          <template v-else-if="hasSearched">
            <div v-if="results.length === 0" class="search-modal__status">
              Nessun preventivo trovato
            </div>
            <ul v-else class="search-results-list">
              <li
                v-for="q in results"
                :key="q.id"
                class="search-result"
                role="button"
                tabindex="0"
                @click="goToQuote(q.id)"
                @keydown.enter="goToQuote(q.id)"
              >
                <div class="search-result__head">
                  <span class="search-result__id">Preventivo #{{ q.id }}</span>
                  <span v-if="q.state" class="search-result__state">{{
                    q.state
                  }}</span>
                </div>
                <div class="search-result__client">{{ q.clientName }}</div>
                <div class="search-result__meta">
                  {{ formatToLocalDate(q.date) }}
                </div>
                <div v-if="q.matchedItems?.length" class="search-result__items">
                  {{ q.matchedItems.join(", ") }}
                </div>
              </li>
            </ul>
          </template>
        </div>
      </template>
    </VueFinalModal>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate } from "../utilities/formatting";

export default {
  name: "HomePage",
  data() {
    return {
      showSearchModal: false,
      searchTerm: "",
      results: [],
      searching: false,
      hasSearched: false,
      suggestions: [],
      showSuggestions: false,
    };
  },
  async mounted() {
    // Assistenza: nel CRM tutti sono richiedenti; nessun accesso "pannello" da valutare
    // (il support/admin vive su assistenza-central) [sc-47544 8C-Emma-6].
    // console.log("this.$route.query", this.$route.query);
    const { firstLogin } = this.$route.query || {};
    if (firstLogin === "1") {
      this.$toast.success(
        "Benvenuto! Abbiamo inviato una password iniziale al tuo indirizzo email"
      );
      // pulisco la query per evitare doppi toast
      const q = { ...this.$route.query };
      delete q.firstLogin;
      this.$router.replace({ path: this.$route.path, query: q });
    }
    const urlParams = new URLSearchParams(window.location.search);
    // console.log("urlParams:", urlParams);
    // if (urlParams.get("calendar") === "connected") {
    //   alert("Google Calendar collegato con successo!");
    // }

    // Logica per google calendar, al momento non utilizzata
    if (urlParams.get("calendar") === "connected") {
      // Mostra un messaggio di successo, ad es.:
      // this.$toast.open("Google Calendar collegato con successo!");
      this.$toast.open({
        message: "Accesso su Google Calendar effettuato con successo",
        type: "success",
      });
    }
    this.$toast.clear();
  },
  methods: {
    ...mapActions(["searchQuotesByItem", "suggestArticles"]),

    formatToLocalDate,

    openSearchModal() {
      this.searchTerm = "";
      this.results = [];
      this.hasSearched = false;
      this.suggestions = [];
      this.showSuggestions = false;
      this.showSearchModal = true;
      this.$nextTick(() => {
        this.$refs.searchInput?.focus();
      });
    },

    closeSearchModal() {
      this.showSearchModal = false;
    },

    // Autocomplete: suggerimenti articoli con debounce mentre si digita
    onSearchInput() {
      const term = this.searchTerm.trim();
      clearTimeout(this._suggestTimer);
      if (!term) {
        this.suggestions = [];
        this.showSuggestions = false;
        return;
      }
      this._suggestTimer = setTimeout(async () => {
        try {
          this.suggestions = await this.suggestArticles({ name: term });
          this.showSuggestions = this.suggestions.length > 0;
        } catch (err) {
          this.suggestions = [];
          this.showSuggestions = false;
        }
      }, 300);
    },

    async selectSuggestion(s) {
      // Un suggerimento identifica un articolo PRECISO: cerco per id esatto,
      // non per testo (il brand da solo tornerebbe articoli diversi con la
      // stessa marca). Mostro comunque la label nel campo di ricerca.
      this.searchTerm = s.name;
      this.showSuggestions = false;
      this.suggestions = [];
      if (s.id == null) {
        this.runSearch();
        return;
      }
      if (this.searching) return;
      clearTimeout(this._suggestTimer);
      this.searching = true;
      try {
        this.results = await this.searchQuotesByItem(
          s.source === "stock" ? { itemId: s.id } : { outstockId: s.id }
        );
        this.hasSearched = true;
      } catch (err) {
        console.error("Errore ricerca preventivi per articolo:", err);
        this.$toast.error("Impossibile eseguire la ricerca.");
      } finally {
        this.searching = false;
      }
    },

    clearSearch() {
      clearTimeout(this._suggestTimer);
      this.searchTerm = "";
      this.suggestions = [];
      this.showSuggestions = false;
      this.results = [];
      this.hasSearched = false;
      this.$refs.searchInput?.focus();
    },

    async runSearch() {
      const name = this.searchTerm.trim();
      if (!name || this.searching) return;
      clearTimeout(this._suggestTimer);
      this.showSuggestions = false;
      this.searching = true;
      try {
        this.results = await this.searchQuotesByItem({ name });
        this.hasSearched = true;
      } catch (err) {
        console.error("Errore ricerca preventivi per articolo:", err);
        this.$toast.error("Impossibile eseguire la ricerca.");
      } finally {
        this.searching = false;
      }
    },

    goToQuote(quoteId) {
      this.showSearchModal = false;
      this.$router.push({ name: "detail-quote", params: { quoteId } });
    },
  },
};
</script>

<style src="@/css/HomePage.css"></style>
